// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"qca-z","subtitle":"rca-z","wrapper":"sca-z","leftArrow":"tca-z","rightArrow":"uca-z"};